import React, { useContext } from 'react';
import myAxios from '../../../myAxios';
import {
  Table,
  Space,
  Spin,
  Row,
  Col,
  message,
  Tooltip,
  Popconfirm,
  Form,
  Modal,
  Tag,
  Input,
  Dropdown,
  Menu,
  Select,
} from 'antd';
import { Button, Icon } from 'semantic-ui-react';
import { LoadingOutlined } from '@ant-design/icons';

import { useState, useEffect } from 'react';
import { UserContext } from '../../../context/UserContext';
import { TamuContext } from '../../../context/TamuContext';
import { useHistory } from 'react-router-dom';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const tableLoading = {
  indicator: <Spin className='loading-data-table' indicator={antIcon} />,
};
const { Option } = Select;
const LihatTamu = () => {
  const [user, setUser] = useContext(UserContext);
  const [tamu, updateTamu, setTamu] = useContext(TamuContext);
  // const [tamu, setTamu] = useState(null);
  const [modalCon, setModalCon] = useState(null);
  const [tempData, setData] = useState(null);
  const [searchText, setSearch] = useState(null);
  const [loadingT, setLoadingT] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingAct, setLoadingAct] = useState(false);
  const [modalVisible, setModal] = useState(false);
  const [instance, setInstance] = useState(null);
  const [idInstance, setIdInstance] = useState(null);
  const [idChairman, setIdChairman] = useState(null);
  let { history } = useHistory;
  const [form] = Form.useForm();

  useEffect(() => {
    // if (!tamu) {
    getInstance();
    if (instance) {
      setLoadingT(tableLoading);
      const timeOutId = setTimeout(() => getTamu(searchText), 500);
      return () => clearTimeout(timeOutId);
    }
    // }
  }, [searchText, idInstance]);

  const getTamu = async (
    search = undefined,
    page = '1',
    sortBy = undefined,
    sorting = 'ASC'
  ) => {
    setLoadingT(tableLoading);

    myAxios
      .get(`guests/${idInstance.id}/${idInstance.type}`, {
        params: {
          type: 'verified',
          search: search,
          show: '10',
          sortBy: sortBy,
          sorting: sorting,
        },
        headers: {
          Authorization: 'Bearer ' + user.token,
        },
      })
      .then((res) => {
        const data = res.data.data.data;
        setTamu(data);
        setLoadingT(false);
      })
      .catch((err) => {
        if (err.response.data.message === 'unauthorized') {
          message.error('Sesi anda telah habis!');
          localStorage.removeItem('user');
          setUser(null);
        } else if (err.response.data.msg === 'Unauthorization Role') {
          message.error(err.response.data.msg);
          history.goBack();
        } else {
          message.error(err.response.data.message);
        }
        setLoadingT(false);
      });
  };

  const getInstance = async () => {
    await myAxios
      .get(`guests-instance`, {
        headers: {
          Authorization: 'Bearer ' + user.token,
        },
      })
      .then((res) => {
        const data = res.data.data;

        if (data.length > 0) {
          if (!idInstance) {
            setIdInstance(data[0]);
            setIdChairman(data[0].chairman_id);
          }
          setInstance(data);
        } else {
          setInstance([]);
        }
      })
      .catch((err) => {
        if (err.response.data.message === 'unauthorized') {
          message.error('Sesi anda telah habis!');
          localStorage.removeItem('user');
        } else if (err.response.data.msg === 'Unauthorization Role') {
          message.error(err.response.data.msg);
          history.goBack();
        } else {
          message.error(err.response.data.msg);
        }
      });
  };

  const onUbahStatusTamu = (param) => {
    setLoadingAct(true);
    myAxios
      .delete(`guest/${param}`, {
        headers: {
          Authorization: 'Bearer ' + user.token,
        },
      })
      .then((res) => {
        message.success(res.data.msg);
        setLoadingAct(false);
        setModal(false);
        form.resetFields();
        getTamu();
      })
      .catch((err) => {
        if (err.response.data.message === 'unauthorized') {
          message.error('Sesi anda telah habis!');
          localStorage.removeItem('user');
          setUser(null);
        } else if (err.response.data.msg === 'Unauthorization Role') {
          message.error(err.response.data.msg);
          history.goBack();
        } else {
          message.error(err.response.data.msg);
        }
        setLoadingAct(false);
      });
  };

  const menu = (
    <Menu>
      {instance &&
        instance.map((val, item) => (
          <Menu.Item>
            <a
              target='_blank'
              rel='noopener noreferrer'
              onClick={() => onChangeFilter(val)}>
              {val.name}
            </a>
          </Menu.Item>
        ))}
    </Menu>
  );

  const onChangeFilter = (val) => {
    setIdInstance(val);
    setIdChairman(val.chairman_id);
  };

  //   const clearFilters = () => {
  //     setTamu(tempData);
  //     setSearch('');
  //   };

  const onChange = () => {};
  const onFocus = () => {};
  const onBlur = () => {};
  const onSearch = () => {};

  const onChangeSearch = (evt) => {
    setSearch(evt.target.value);
  };

  const handleCancel = () => {
    setModal(false);
    form.resetFields();
  };

  const handleReset = () => {
    if (modalCon.data === null) form.resetFields();
    else {
      form.setFieldsValue({
        nama: modalCon.data.name,
        email: modalCon.data.email,
        nip: modalCon.data.nip,
      });
    }
  };

  const onFinish = (values) => {
    setLoading(true);
    if (modalCon.judul === 'Tambah Tamu') {
      if (values.nip === undefined || values.nip === '') values.nip = '-';
      if (values.institusi === undefined || values.institusi === '')
        values.institusi = '-';

      let newObj = {
        name: values.nama,
        email: values.email,
        nip: values.nip,
        type_id: instance.filter((e) => {
          return e.type === values.instance;
        })[0].id,
        institusi: values.institusi,
      };
      myAxios
        .post(`guest`, newObj, {
          headers: {
            Authorization: 'Bearer ' + user.token,
          },
        })
        .then((res) => {
          message.success(res.data.msg);
          setLoading(false);
          setModal(false);
          form.resetFields();
          getTamu();
        })
        .catch((err) => {
          if (err.response.data.message === 'unauthorized') {
            message.error('Sesi anda telah habis!');
            localStorage.removeItem('user');
            setUser(null);
          } else if (err.response.data.msg === 'Unauthorization Role') {
            message.error(err.response.data.msg);
            history.goBack();
          } else {
            message.error(err.response.data.msg);
          }
          setLoading(false);
        });
    } else {
      if (values.nip === undefined || values.nip === '') values.nip = '-';

      let newObj = {
        name: values.nama,
        email: values.email,
        nip: values.nip,
        institusi: values.institusi,
      };

      myAxios
        .put(`guest/${modalCon.data.id}`, newObj, {
          headers: {
            Authorization: 'Bearer ' + user.token,
          },
        })
        .then((res) => {
          message.success(res.data.msg);
          setLoading(false);
          setModal(false);
          form.resetFields();
          getTamu();
        })
        .catch((err) => {
          if (err.response.data.message === 'unauthorized') {
            message.error('Sesi anda telah habis!');
            localStorage.removeItem('user');
            setUser(null);
          } else if (err.response.data.msg === 'Unauthorization Role') {
            message.error(err.response.data.msg);
            history.goBack();
          } else {
            message.error(err.response.data.msg);
          }
          setLoading(false);
        });
    }
  };

  const onFinishFailed = (errorInfo) => {};

  const onTambahModal = async (evt) => {
    // await getInstance();
    setModal(true);
    setModalCon({
      judul: 'Tambah Tamu',
      id: null,
    });

    form.setFieldsValue({
      instance: idInstance.type,
    });
  };
  const onEditModal = (param) => {
    setModal(true);
    setModalCon({
      judul: 'Ubah Tamu',
      data: param,
    });

    form.setFieldsValue({
      nama: param.name,
      email: param.email,
      nip: param.nip,
      instance: param.guestable_id,
    });
  };

  const columns = [
    {
      title: 'Nama',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.length - b.name.length,
      ellipsis: true,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      // sorter: (a, b) => a.email.length - b.email.length,
      ellipsis: true,
    },
    {
      title: 'Institusi',
      dataIndex: 'institution',
      key: 'institution',
      sorter: (a, b) => a.institution.length - b.institution.length,
      ellipsis: true,
    },
    {
      title: 'Nomor Induk Pegawai',
      dataIndex: 'nip',
      key: 'nip',
      sorter: (a, b) => a.nip.length - b.nip.length,
      ellipsis: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: (a, b) => a.status.length - b.status.length,
      render: (dataIndex) => (
        <Tag color={dataIndex === 'Terverifikasi' ? 'green' : 'red'}>
          {dataIndex}
        </Tag>
      ),
    },

    {
      key: 'action',
      dataIndex: 'id',
      align: 'center',
      render: (dataIndex, row, c) => (
        <div>
          {!loadingAct && idChairman && (
            <>
              {user.id === idChairman && (
                <Space size='middle'>
                  <Tooltip
                    placement='bottom'
                    title='Ubah Data Tamu'
                    color='#1f1f1f'
                    key='white'>
                    <Button
                      className='aksiEdit'
                      color='facebook'
                      size='mini'
                      icon='pencil alternate'
                      onClick={() => onEditModal(row)}
                    />
                  </Tooltip>

                  <Tooltip
                    placement='bottom'
                    title='Ubah Status'
                    color='#1f1f1f'
                    key='white'>
                    <Popconfirm
                      placement='bottomRight'
                      title='Apakah yakin ingin mengubah status tamu ?'
                      onConfirm={() => onUbahStatusTamu(dataIndex)}
                      okText='Ubah'
                      cancelText='Batal'>
                      <Button
                        className='aksiHapus'
                        color='yellow'
                        icon='exchange'
                        size='mini'></Button>
                    </Popconfirm>
                  </Tooltip>
                </Space>
              )}
            </>
          )}
          {loadingAct && (
            <Spin className='loading-data-table' indicator={antIcon} />
          )}
        </div>
      ),
    },
  ];

  return (
    <div className=''>
      <Row justify='space-between' style={{ marginBottom: '20px' }}>
        <Col md={12} sm={24}>
          <Space>
            <Button
              className='btn-hapus-filter'
              onClick={onTambahModal}
              icon
              labelPosition='left'
              color='green'>
              <Icon name='user plus' />
              Tambah Tamu
            </Button>
            {/* <Button
              secondary
              className='btn-hapus-filter'
              type='danger'
              onClick={clearFilters}>
              Hapus Filter
            </Button> */}
            {instance && (
              <Dropdown
                overlay={menu}
                placement='bottomLeft'
                trigger={['click']}>
                <Button
                  secondary
                  className='btn-hapus-filter'
                  icon='angle down'
                  labelPosition='right'
                  content={
                    !idInstance
                      ? 'Filter Instansi'
                      : instance[
                          instance.findIndex((x) => x.name === idInstance.name)
                        ].name
                  }
                />
              </Dropdown>
            )}
          </Space>
        </Col>
        <Col md={12} sm={24} style={{ width: '100%' }} className='mt-mobile'>
          <Input
            value={searchText}
            style={{ width: '100%' }}
            placeholder='Cari data tamu disini'
            onChange={onChangeSearch}
          />
        </Col>
      </Row>

      <Table
        loading={loadingT}
        loadingIndicator={antIcon}
        columns={columns}
        dataSource={tamu}
        scroll={{ x: 600, y: 1500 }}
        size='small'
      />

      {modalCon && (
        <Modal
          centered
          visible={modalVisible}
          onCancel={handleCancel}
          footer={[]}
          title={modalCon.judul}>
          <Form
            layout='vertical'
            form={form}
            name='basic'
            initialValues={{ remember: false }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}>
            <Form.Item
              labelAlign='left'
              label='Nama'
              name='nama'
              rules={[
                {
                  required: true,
                  message: 'Bagian ini wajib diisi',
                },
              ]}>
              <Input placeholder='Masukan nama tamu' />
            </Form.Item>

            <Form.Item
              labelAlign='left'
              label='Email'
              name='email'
              rules={[
                {
                  type: 'email',
                  message: 'Bagian ini wajib diisi!',
                  required: true,
                },
              ]}>
              <Input placeholder='Masukan email tamu' />
            </Form.Item>

            <Form.Item labelAlign='left' label='Nomor Induk Pegawai' name='nip'>
              <Input placeholder='Masukan NIP tamu' />
            </Form.Item>
            <Form.Item
              labelAlign='left'
              label='Institusi Asal'
              name='institusi'>
              <Input placeholder='Masukan institusi asal tamu' />
            </Form.Item>

            {instance && !modalCon.id && (
              <Form.Item
                labelAlign='left'
                label='Kantor/Unit/SubUnit'
                name='instance'
                rules={[
                  {
                    required: true,
                    message: 'Bagian ini wajib diisi',
                  },
                ]}>
                <Select
                  style={{ width: '100%' }}
                  autoComplete='off'
                  showSearch
                  placeholder='Pilih Kantor/Unit/SubUnit'
                  optionFilterProp='label'
                  onChange={onChange}
                  onFocus={onFocus}
                  onBlur={onBlur}
                  onSearch={onSearch}
                  // filterOption={(input, option) =>
                  //   option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  //   0
                  // }
                >
                  {instance.map((val, item) => (
                    <Option key={val.type} value={val.type} label={val.name}>
                      {val.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            <Form.Item>
              <Button
                floated='right'
                type='submit'
                loading={loading}
                color='green'>
                Simpan
              </Button>

              <Button
                type='button'
                floated='right'
                onClick={handleReset}
                loading={loading}
                negative>
                Reset
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

export default LihatTamu;
